<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">过车记录查询</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="通过时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem"
              unlink-panels
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="停车场">
            <el-select v-model="parkingCode" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in parkingCodeArr"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="carNumber" placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="车辆类型">
            <el-select v-model="carModel" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in carModelArr"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="车辆颜色">
            <el-select v-model="carColor" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in carColorArr"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="dataTime"
                label="时间"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="parkingName"
                label="停车场"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="type"
                label="方向"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="entranceName"
                label="出入口"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="carNumber"
                label="车牌号"
                align="center"
              ></el-table-column>
              <!-- <el-table-column
                prop="carModel"
                label="车辆类型"
              ></el-table-column> -->
              <el-table-column
                prop="carColor"
                label="车辆颜色"
                align="center"
              ></el-table-column>
            </el-table>
            <el-dialog
              class="emergencyoperations-dialog normal"
              custom-class="bg3"
              top="6vh"
              :modal-append-to-body="false"
              :append-to-body="true"
              :visible.sync="isShowPop"
              :close-on-click-modal="true"
              :close-on-press-escape="false"
              :show-close="true"
              :destroy-on-close="true"
            >
              <img :src="bigImg" class="bigimg" alt="" />
            </el-dialog>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import { getList, CarParkRecordInOut } from "@/api/src/entityBaseAllInfo";
import moment from "moment";
export default {
  name: "CarRecordListView",
  controller: "UI",
  action: "CarRecordListView",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      PlateNo: "",
      date: [
        moment(new Date().getTime()).format("YYYY-MM-DD"),
        moment(new Date().getTime()).format("YYYY-MM-DD"),
      ],
      bigImg: "",
      isShowPop: false,
      carNumber: "", //车牌号
      parkingCodeArr: [],
      parkingCode: "",
      carModelArr: [
        { type: "0", name: "其他车" },
        { type: "1", name: "小型车" },
        { type: "2", name: "大型车" },
        { type: "3", name: "摩托车" },
      ],
      carModel: "",
      carColor: "",
      carColorArr: [
        { type: "0", name: "其他颜色" },
        { type: "1", name: "白色" },
        { type: "2", name: "银色" },
        { type: "3", name: "灰色" },
        { type: "4", name: "黑色" },
        { type: "5", name: "红色" },
        { type: "6", name: "深蓝色" },
        { type: "7", name: "蓝色" },
        { type: "8", name: "黄色" },
        { type: "9", name: "绿色" },
        { type: "10", name: "棕色" },
        { type: "11", name: "粉色" },
        { type: "12", name: "紫色" },
      ],
    };
  },
  created: function () {
    this.getParkListData();
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        dataStartTime: this.date[0],
        dataEndTime: this.date[1],
        parkingCode: this.parkingCode,
        carModel: this.carModel,
        carColor: this.carColor,
        carNumber: this.carNumber,
      };
      CarParkRecordInOut(params).then((res) => {
        // console.log("停车场过车记录")
        // console.log(res)
        that.total = res.count;
        that.tableData = res.data;
      });
    },
    getParkListData() {
      let that = this;
      let params = {
        page: 1,
        size: 999,
        typeOneCode: "parking", //单位类型编码  景区scene  景点 sceneSpot  停车场 parking
      };
      getList(params).then((res) => {
        // console.log("停车场列表")
        // console.log(res)
        that.parkingCodeArr = res.data;
      });
    },
    lookBigImg(src) {
      this.bigImg = `https://docking.xjtstc.com/preview?file_id=${src}`;
      this.isShowPop = true;
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.getData();
    },
    clearsearch() {
      this.carModel = "";
      this.carColor = "";
      this.carNumber = "";
      this.parkingCode = "";
      this.date = [new Date(), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.smallImg {
  width: 30px;
  height: 30px;
}
.bigimg {
  width: 95%;
  height: 95%;
}
</style>